var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('inputOptional',{attrs:{"value":_vm.password,"label":"Zugangs-Passwort des Terminkalenders","callback":_vm.setPassword}}),_c('info',{staticStyle:{"display":"inline"}},[_vm._v(" Passwortschutz ist optional ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }